const { build, qs } = require('../../libs/qs')
const {
    Pixel,
    bubblesort,
    channel_shuffle,
    shuffle,
    sort_some,

    brightness,
    channel_range,
    channel_range1,
    channel_range2,
    channel_range3,
    channel_range4,

    channel_range5,
    channel_range6,
    obj_list,

    randInt,
    calculateBrightness,
    shufflearray,
    logSlider,
    RandomNumber, unwrap } = require('./glitchutils')

const createCanvas = (w, h) => {
    if (typeof OffscreenCanvas !== 'undefined') {
        const c = new OffscreenCanvas(w, h);
        c.toDataURL = async (type = 'image/png', quality) => {
            const blob = await c.convertToBlob({ type, quality });
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });
        };
        c.loadImage = async (src) => {
            const blob = await (await fetch(src)).blob();
            return await createImageBitmap(blob);
        };
        return c;
    }
    const c = build('canvas');
    c.width = w;
    c.height = h;
    return c;
};

const createImageFromDataURL = async (dataURL) => {
    const blob = await (await fetch(dataURL)).blob();
    return await createImageBitmap(blob);
};



const lib = {

    latglitch: (canvas, ctx, ctrl) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width


                if (ctrl != 0) {
                    const latseed = randInt(0, Math.pow(ctrl, 4) * 2000);

                    for (let i = 0; i < latseed; i++) {
                        const x = Math.random() * W;
                        const y = Math.random() * H;
                        const SW = W - x;
                        const SH = randInt(5, H / 4);
                        ctx.drawImage(canvas, 0, y, SW, SH, x, y, SW, SH);
                        ctx.drawImage(canvas, SW, y, x, SH, 0, y, x, SH);
                    }
                }
                resolve()
            } catch (e) {

                console.error(e)
                reject(e)
            }
        })
    },
    sinuglitch: (canvas, ctx, _1, _2, _3, _4) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                let tempCanvas = createCanvas(W, H)
                let tempCtx = tempCanvas.getContext('2d')

                tempCtx.drawImage(canvas, 0, 0, W, H)

                const wavelength = Math.pow(_1, 4) * 10000
                const period = _2;
                const amp = _3;
                const shading = 0.5;
                const od = ctx.getImageData(0, 0, W, H).data;
                const id = ctx.getImageData(0, 0, W, H);
                const d = id.data;
                const now = Date.now() / period;
                for (let y = 0; y < H; ++y) {
                    const amplitude = Math.floor(Math.random() * amp);
                    let lastO = 0,
                        shade = 0;
                    for (let x = 0; x < W; ++x) {
                        const px = (y * W + x) * 4;
                        const o = Math.sin(x / wavelength - now) * amplitude * x / W;
                        let opx = ((y + o << 0) * W + x) * 4;

                        shade = (o - lastO) * shading;
                        d[px] = od[opx] - shade;

                        if (d[px] > _4) {
                            d[px] = od[px]
                        }
                        d[px + 1] = od[opx + 1] + shade;
                        if (d[px + 1] > _4) {
                            d[px + 1] = od[px + 1]
                        }
                        d[px + 2] = od[opx + 2] + shade;
                        if (d[px + 2] > _4) {
                            d[px + 2] = od[px + 2]
                        }
                        d[px + 3] = od[px + 3];

                        lastO = o;
                    }

                }
                for (let i = 0; i < id.data.length; i += 4) {
                    if (id.data[i] + id.data[i + 1] + id.data[i + 2] < 10) {
                        id.data[i + 3] = 0; // alpha
                    }
                }

                tempCtx.putImageData(id, 0, 0);
                ctx.drawImage(tempCanvas, 0, 0, W, H)



                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }

        })
    },
    rgbdesync: (canvas, ctx, ctrl2, ctrl3, ctrl4) => {
        return new Promise((resolve, reject) => {
            try {

                const H = canvas.height
                const W = canvas.width

                const randR = Math.floor(Math.random() * ctrl2);
                const randG = Math.floor(Math.random() * ctrl3) * 3;
                const randB = Math.floor(Math.random() * ctrl4);

                const imageData = ctx.getImageData(0, 0, W, H);
                const data = imageData.data;

                for (let i = 0, len = imageData.width * imageData.height; i < len; i++) {

                    data[i * 4 + 0] = data[(i + randR) * 4 + 0];
                    data[i * 4 + 1] = data[(i + randG) * 4 + 1];
                    data[i * 4 + 2] = data[(i + randB) * 4 + 2];
                    data[i * 4 + 3] = 255;
                }

                ctx.putImageData(imageData, 0, 0, 0, 0, W, H);

                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    base64glitcher: async (canvas, ctx, ctrl) => {
        const maxRetries = 3;
        let lastError;
        
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
                const H = canvas.height
                const W = canvas.width
                const dataurl = await canvas.toDataURL("image/jpeg");
                const input = dataurl.replace('data:image/jpeg;base64,', '');
                const chars1 = ["0", ")", "<", ">", ".", "*", "&", "£", "%", "~", "#", "+", "a", "!", "|", "-"];
                const chars2 = ["a", "b", "c", "d", "e", "f", "z", "x", "v", "n", "m", "o", "i", "y", "q", "w"];
                const chars = Math.floor((Math.random() * 2) + 1) == 2 ? chars2 : chars1;
                const glitch_levels = ["64", "128", "256", "1024", "2048", "4056", "8112"];
                const splitNum = glitch_levels[ctrl];
                let newdata;
                try {
                    newdata = atob(input);
                } catch (err) {
                    newdata = input;
                }
                const chunkLength = parseInt((newdata.length - 1) / splitNum);
                const chunks = [];
                for (let i = 0, charsLength = newdata.length; i < charsLength; i += chunkLength) {
                    chunks.push(newdata.substring(i, i + chunkLength));
                }
                for (let i = 2; i <= splitNum; i++) {
                    let glitchRand = Math.floor((Math.random() * 100) + 1);
                    if (ctrl == 4) glitchRand = 1;
                    const char1Rand = Math.floor((Math.random() * chars.length));
                    let char2Rand = Math.floor((Math.random() * chars.length));
                    if (char2Rand == char1Rand) char2Rand = "9";
                    if (glitchRand % 2 != 0) chunks[i] = chunks[i].replace(chars[char1Rand], chars[char2Rand]);
                }
                newdata = chunks.join('');
                const base64data = btoa(newdata);
                const glitched_img = await createImageFromDataURL('data:image/jpeg;base64,' + base64data);
                ctx.drawImage(glitched_img, 0, 0, W, H);
                glitched_img.close();
                return;
            } catch (e) {
                lastError = e;
                console.error(`[base64glitcher] Attempt ${attempt}/${maxRetries} failed:`, e);
                if (attempt < maxRetries) {
                    await new Promise(resolve => setTimeout(resolve, 100));
                }
            }
        }
        console.error('[base64glitcher] All retries failed:', lastError);
    },
    base64glitcher2: async (canvas, ctx, force) => {
        const maxRetries = 3;
        let lastError;
        
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
                let corrupted = await canvas.toDataURL("image/jpeg");
                const maxGlitch = force * 2;
                const offset = 2000;
                let glitch = Math.round(Math.random() * maxGlitch);
                for (let i = 0; i < glitch; i++) {
                    const p = offset + Math.round(Math.random() * (corrupted.length - offset - 1));
                    corrupted = corrupted.substr(0, p) + corrupted.charAt(p + 1) + corrupted.charAt(p) + corrupted.substr(p + 2);
                }
                const img = await createImageFromDataURL(corrupted);
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                img.close();
                return;
            } catch (e) {
                lastError = e;
                console.error(`[base64glitcher2] Attempt ${attempt}/${maxRetries} failed:`, e);
                if (attempt < maxRetries) {
                    await new Promise(resolve => setTimeout(resolve, 100));
                }
            }
        }
        console.error('[base64glitcher2] All retries failed:', lastError);
    },

    rotatedbase64glitcher: async (canvas, ctx, ctrl, pass) => {
        try {
            for (let i = 0; i <= pass; i++) {
                await lib.base64glitcher(canvas, ctx, ctrl);
            }
        } catch (e) {
            console.error(e);
        }
    },
    verticalsplicer: (canvas, ctx, force) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                for (let i = 0; i < force; i++) {
                    const dataslices = [];
                    const larg = W / force;
                    let f = 0;
                    for (let i = 0; i < force; i++) {
                        dataslices[i] = ctx.getImageData(f, 0, larg, H);
                        f += larg;
                    }
                    shufflearray(dataslices);
                    let t = 0;
                    for (let i = 0; i < dataslices.length; i++) {
                        ctx.putImageData(dataslices[i], t, 0);
                        t += larg;
                    }
                    dataslices.length = 0;
                }
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    horizontalsplicer: (canvas, ctx, force) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                for (let i = 0; i < force; i++) {
                    const dataslices = [];

                    const larg = H / force;
                    let f = 0;
                    for (let i = 0; i < force; i++) {
                        dataslices[i] = ctx.getImageData(0, f, W, larg);
                        f += larg;
                    }
                    shufflearray(dataslices);
                    let t = 0;
                    for (let i = 0; i < dataslices.length; i++) {
                        ctx.putImageData(dataslices[i], 0, t);
                        t += larg;
                    }
                    dataslices.length = 0;

                }
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    pixelsort: (canvas, ctx, mode, f1, force, f2, f3) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                if (mode != 0) {
                    const data = ctx.getImageData(0, 0, W, H);

                    const old_pixelSequence = obj_list(data.data);
                    let new_pixelSequence;
                    switch (Number(mode)) {

                        case 1:
                            new_pixelSequence = channel_range(old_pixelSequence, W, f1, f2, f3);

                            break;
                        case 2:
                            new_pixelSequence = channel_range1(old_pixelSequence, W, f1, f2, f3);

                            break;
                        case 3:
                            new_pixelSequence = channel_range2(old_pixelSequence, W, f1, f2, f3);
                            break;
                        case 4:
                            new_pixelSequence = channel_range3(old_pixelSequence, W, f1, f2, f3);
                            break;
                        case 5:
                            new_pixelSequence = channel_range4(old_pixelSequence, W, f1, f2, f3);
                            break;
                        case 6:
                            new_pixelSequence = channel_range5(old_pixelSequence, W, f1, f2, f3);
                            break;
                        case 7:
                            new_pixelSequence = channel_range6(old_pixelSequence, W, f1, f2, f3);

                            break;
                        case 8:
                            new_pixelSequence = channel_range3(channel_range6(old_pixelSequence, W, f1, f2, f3), W, f1, f2, f3);

                            break;
                        case 9:
                            new_pixelSequence = channel_range2(channel_range5(old_pixelSequence, W, f1, f2, f3), W, f1, f2, f3);

                            break;
                        case 10:
                            new_pixelSequence = channel_range(channel_range3(old_pixelSequence, W, f1, f2, f3), W, f1, f2, f3);

                            break;


                    }
                    data.data.set(unwrap(new_pixelSequence));
                    ctx.putImageData(data, 0, 0);
                }
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    scanlines: (canvas, ctx, space, opacity) => {
        return new Promise((resolve, reject) => {
            try {

                const H = canvas.height
                const W = canvas.width
                for (let i = 0; i < H; i++) {
                    if (i % Number(space) == 0) {
                        ctx.fillStyle = '#000';
                        ctx.globalAlpha = opacity;
                        ctx.fillRect(0, 0 + i, W, 1);
                        ctx.globalAlpha = 1.0
                    }
                }
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    jpeg: async (canvas, ctx, quality) => {
        const maxRetries = 3;
        let lastError;
        
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
                const H = canvas.height
                const W = canvas.width
                const dataURL = await canvas.toDataURL("image/jpeg", Number(quality));
                const blob = await (await fetch(dataURL)).blob();
                const bitmap = await createImageBitmap(blob);
                ctx.drawImage(bitmap, 0, 0, W, H);
                bitmap.close();
                return;
            } catch (e) {
                lastError = e;
                console.error(`[jpeg] Attempt ${attempt}/${maxRetries} failed:`, e);
                if (attempt < maxRetries) {
                    await new Promise(resolve => setTimeout(resolve, 100));
                }
            }
        }
        console.error('[jpeg] All retries failed:', lastError);
    },
    Imgslice: (canvas, inputctx, numberofslice) => {
        return new Promise((resolve, reject) => {
            try {
                let sourceX = 0;
                let sourceY = 0;
                let destX = 0;
                let destY = 0;
                const slicesArray = [];
                const slicesArray2 = [];
                const ctxArray = [];
                const slicewidth = parseInt((canvas.width / numberofslice));
                for (var i = 0; i < numberofslice; i++) {
                    slicesArray[i] = createCanvas(640, 640);
                    ctxArray[i] = slicesArray[i].getContext('2d');
                    ctxArray[i].drawImage(canvas, 0, sourceX, 640, 640, 0, 0, slicewidth, 640);
                    slicesArray2[i] = inputctx.getImageData(sourceX, 0, canvas.width, canvas.height);
                    sourceX = sourceX + slicewidth;
                }
                destY = RandomNumber();
                shuffle(slicesArray);
                shuffle(slicesArray2);
                for (let i = 0; i < slicesArray.length; i++) {
                    inputctx.globalCompositeOperation = "lighter";
                    inputctx.drawImage(slicesArray[i], destX, destY);
                    destY = RandomNumber();
                    inputctx.putImageData(slicesArray2[i], destX, destY);
                    inputctx.globalCompositeOperation = "lighter";
                    inputctx.drawImage(slicesArray[i], destY, destX);
                    destX = destX + slicewidth;
                }

                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    deconstruct: (canvas, ctx, force) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                for (let i = 0; i < force; i++) {
                    const x = randInt(0, W);
                    const y = randInt(0, H);
                    const data = ctx.getImageData(x, y, Math.max(1, randInt(0, (W - x))), Math.max(1, randInt(0, (H - y))))
                    ctx.putImageData(data, randInt(-W / 2, W), randInt(-H / 2, H));
                }
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    flip: (canvas, ctx, ctrl) => {
        return new Promise((resolve, reject) => {
            const H = canvas.height
            const W = canvas.width
            try {
                switch (ctrl) {
                    case "0":


                        break;
                    case "1":
                        ctx.save(); // Save the current state
                        ctx.scale(-1, 1); // Set scale to flip the image
                        ctx.drawImage(canvas, -W, 0, W, H); // draw the image
                        ctx.restore();

                        break;
                    case "2":
                        ctx.save(); // Save the current state
                        ctx.scale(1, -1); // Set scale to flip the image
                        ctx.drawImage(canvas, 0, -H, W, H); // draw the image
                        ctx.restore();

                        break;
                    case "3":
                        ctx.save(); // Save the current state
                        ctx.scale(-1, -1); // Set scale to flip the image
                        ctx.drawImage(canvas, -W, -H, W, H); // draw the image
                        ctx.restore();

                        break;
                    default:
                        break

                }
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }

        })
    },
    mirror: (canvas, ctx, ctrl) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                var xt = 0;
                switch (ctrl) {
                    case "1":
                        ctx.save();

                        ctx.translate(W / (4 + xt), 0 - xt);

                        ctx.scale(-1, 1);

                        ctx.drawImage(canvas,
                            /*source */
                            W / (2 + xt), 0, W / (2 - xt), H,
                            /*destination*/
                            -W / (4 - xt), 0, W / (2 + xt), H);

                        ctx.restore();

                        break;

                    case "2":
                        ctx.save();

                        ctx.translate(W / (2 - xt), 0);

                        ctx.scale(-1, (1 + xt));

                        ctx.drawImage(canvas,
                            /*source */
                            0, 0, W / (2 + xt), H,
                            /*destination*/
                            -W / (2 + xt), 0, W / (2 - xt), H);

                        ctx.restore();

                        break;
                    case "3":
                        ctx.save();
                        ctx.translate(0, H / 4);
                        ctx.scale(1, -1);

                        ctx.drawImage(canvas, 0, H / 2, W, H / 2, 0, -H / 4, W, H / 2);
                        ctx.restore();
                        break;

                    case "4":

                        ctx.save();
                        ctx.translate(0, H / 2);
                        ctx.scale(1, -1);

                        ctx.drawImage(canvas, 0, 0, W, H / 2, 0, -H / 2, W, H / 2);
                        ctx.restore();

                        break;
                    case "5":
                        ctx.save();

                        ctx.translate(W / 4, 0);

                        ctx.scale(-1, 1);

                        ctx.drawImage(canvas,
                            /*source */
                            W / 2, 0, W / 2, H,
                            /*destination*/
                            -W / 4, 0, W / 2, H);
                        // restore context
                        ctx.restore();

                        ctx.save();
                        ctx.translate(0, H / 2);
                        ctx.scale(1, -1);

                        ctx.drawImage(canvas, 0, 0, W, H / 2, 0, -H / 2, W, H / 2);
                        ctx.restore();

                        break;

                    case "6":
                        ctx.save();

                        ctx.translate(W / 2, 0);

                        ctx.scale(-1, 1);

                        ctx.drawImage(canvas,
                            /*source */
                            0, 0, W / 2, H,
                            /*destination*/
                            -W / 2, 0, W / 2, H);

                        ctx.restore();
                        ctx.save();
                        ctx.translate(0, H / 2);
                        ctx.scale(1, -1);

                        ctx.drawImage(canvas, 0, 0, W, H / 2, 0, -H / 2, W, H / 2);
                        ctx.restore();

                        break;

                    case "7":
                        ctx.save();

                        ctx.translate(W / 4, 0);

                        ctx.scale(-1, 1);

                        ctx.drawImage(canvas,
                            /*source */
                            W / 2, 0, W / 2, H,
                            /*destination*/
                            -W / 4, 0, W / 2, H);

                        ctx.restore();
                        ctx.save();
                        ctx.translate(0, H / 2);
                        ctx.scale(1, -1);

                        ctx.drawImage(canvas, 0, 0, W, H / 2, 0, -H / 2, W, H / 2);
                        ctx.restore();

                        break;

                    case "8":
                        ctx.save();

                        ctx.translate(W / 2, 0);

                        ctx.scale(-1, 1);

                        ctx.drawImage(canvas,
                            /*source */
                            0, 0, W / 2, H,
                            /*destination*/
                            -W / 2, 0, W / 2, H);

                        ctx.restore();

                        ctx.save();
                        ctx.translate(0, H / 2);
                        ctx.scale(1, -1);

                        ctx.drawImage(canvas, 0, 0, W, H / 2, 0, -H / 2, W, H / 2);
                        ctx.restore();

                        break;
                    case "9":
                        ctx.save();

                        ctx.translate(W / 4, 0);

                        ctx.scale(-1, 1);

                        ctx.drawImage(canvas,
                            /*source */
                            0, 0, W / 2, H,
                            /*destination*/
                            W / 4, 0, -W / 2, H);

                        ctx.restore();

                        break;


                    case "10":

                        ctx.save();

                        ctx.scale(1 + xt, 1 + xt);

                        ctx.drawImage(canvas, -xt * 100, -xt * 100, W, H);

                        ctx.restore();


                        break;
                    case "0":

                        break;

                }
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    invert: (canvas, ctx) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width

                var imageData = ctx.getImageData(0, 0, W, H);
                var buf8 = new Uint8ClampedArray(imageData.data.buffer);
                var data32 = new Uint32Array(imageData.data.buffer);


                for (var i = 0; i < data32.length; i++) {

                    var tmpixel = data32[i];
                    var a = (tmpixel & 0xff000000) >> 24;
                    if (a === -1) {
                        a = 255;
                    }
                    var b = (tmpixel & 0x00ff0000) >> 16; //blue channel
                    var g = (tmpixel & 0x0000ff00) >> 8; //green channel
                    var r = (tmpixel & 0x000000ff) >> 0; // red channel
                    b = 255 - b;
                    g = 255 - g;
                    r = 255 - r;
                    data32[i] =
                        (a << 24) | // alpha
                        (b << 16) | // blue
                        (g << 8) | // green
                        r; // r

                }
                imageData.data.set(buf8);
                ctx.putImageData(imageData, 0, 0);

                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }

        })
    },
    brightness: (canvas, ctx, delta) => {
        return new Promise((resolve, reject) => {
            try {
                delta = parseInt(delta);
                if (delta != 0) {

                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const buf8 = new Uint8ClampedArray(imageData.data.buffer);
                    const data32 = new Uint32Array(imageData.data.buffer);

                    //var d = imageData.data;
                    for (let i = 0; i < data32.length; i++) {

                        let tmpixel = data32[i];
                        //  var a = (tmpixel & 0xff000000) >> 24;

                        //if(a=== -1){
                        //  a=255;
                        //}
                        let r = (tmpixel & 0x000000ff) >> 0;
                        let g = (tmpixel & 0x0000ff00) >> 8;
                        let b = (tmpixel & 0x00ff0000) >> 16;

                        r = r + delta; // red
                        if (r < 0) {
                            r = 0;
                        } else if (r > 255) {
                            r = 255;
                        }
                        g = g + delta; // red
                        if (g < 0) {
                            g = 0;
                        } else if (g > 255) {
                            g = 255;
                        }
                        b = b + delta; // red
                        if (b < 0) {
                            b = 0;
                        } else if (b > 255) {
                            b = 255;
                        }
                        data32[i] =
                            (255 << 24) |
                            (b << 16) | // blue
                            (g << 8) | // green
                            r;

                    }



                    imageData.data.set(buf8);
                    ctx.putImageData(imageData, 0, 0);
                }
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })

    },
    contrast: (canvas, ctx, value) => {
        return new Promise((resolve, reject) => {
            try {



                value = value - 1

                value = (parseFloat(value) || 0) + 1;

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const buf8 = new Uint8ClampedArray(imageData.data.buffer);
                const data32 = new Uint32Array(imageData.data.buffer);


                for (let i = 0; i < data32.length; i++) {
                    let tmpixel = data32[i];
                    let a = (tmpixel & 0xff000000) >> 24;
                    let b = (tmpixel & 0x00ff0000) >> 16;
                    let g = (tmpixel & 0x0000ff00) >> 8;
                    let r = (tmpixel & 0x000000ff) >> 0;

                    r = ((((r / 255) - 0.5) * value) + 0.5) * 255;
                    g = ((((g / 255) - 0.5) * value) + 0.5) * 255;
                    b = ((((b / 255) - 0.5) * value) + 0.5) * 255;
                    if (r < 0) {
                        r = 0;
                    } else if (r > 255) {
                        r = 255;
                    }

                    if (g < 0) {
                        g = 0;
                    } else if (g > 255) {
                        g = 255;
                    }

                    if (b < 0) {
                        b = 0;
                    } else if (b > 255) {
                        b = 255;
                    }
                    data32[i] =
                        (a << 24) |
                        (b << 16) | // blue
                        (g << 8) | // green
                        r;
                }
                imageData.data.set(buf8);
                ctx.putImageData(imageData, 0, 0);

                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })

    },
    RandBlocks: (canvas, ctx, blockSize, unified) => {
        return new Promise(async (resolve, reject) => {
            try {
                let maxw = Math.floor(canvas.width / blockSize)
                let maxh = Math.floor(canvas.height / blockSize)
                ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, maxw * blockSize, maxh * blockSize)
                const squares = []
                for (let y = 0; y < maxh; y++) {
                    for (let x = 0; x < maxw; x++) {
                        const squareimgdata = ctx.getImageData(x * blockSize, y * blockSize, blockSize, blockSize)
                        const temp = []
                        const d = squareimgdata.data
                        for (let rgb = 0; rgb < d.length; rgb += 4) {
                            temp.push({
                                r: d[rgb],
                                g: d[rgb + 1],
                                b: d[rgb + 2],
                            })
                        }
                        shufflearray(temp)
                        let idx = 0
                        let average
                        if (unified > 0) {
                            const rs = []
                            const gs = []
                            const bs = []
                            temp.forEach(data => {
                                rs.push(data.r)
                                gs.push(data.g)
                                bs.push(data.b)
                            })

                            average = {
                                r: rs.reduce((a, b) => a + b) / rs.length,
                                g: gs.reduce((a, b) => a + b) / gs.length,
                                b: bs.reduce((a, b) => a + b) / bs.length
                            }
                        }

                        for (let rgb = 0; rgb < d.length; rgb += 4) {
                            if (unified > 0) {
                                d[rgb] = average.r
                                d[rgb + 1] = average.g
                                d[rgb + 2] = average.b

                            } else {
                                d[rgb] = temp[idx].r
                                d[rgb + 1] = temp[idx].g
                                d[rgb + 2] = temp[idx].b
                            }

                            idx++

                        }

                        squares.push(squareimgdata)

                    }
                }

                let idx = 0
                for (let y = 0; y < maxh; y++) {
                    for (let x = 0; x < maxw; x++) {

                        ctx.putImageData(squares[idx], x * blockSize, y * blockSize)

                        idx++

                    }
                }
                ctx.drawImage(canvas, 0, 0, maxw * blockSize, maxh * blockSize, 0, 0, canvas.width, canvas.height)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })

    },
    ImageParticules: (canvas, ctx, angle, cycles, compositing = 0) => {
        return new Promise(async (resolve, reject) => {
            try {
                // create some particules from fragment of the canvas 
                // and move them arround using angle and cycles

                const H = canvas.height
                const W = canvas.width

                if (!isFinite(W) || !isFinite(H) || W <= 0 || H <= 0) {
                    return resolve();
                }

                angle = isNaN(angle) ? 0 : Number(angle);
                cycles = isNaN(cycles) ? 0 : Math.max(0, Math.min(20, Number(cycles))); // limit cycles to 0-20
                compositing = Number(compositing) || 0;

                const maxParticules = 100; // reduced for performance

                const particules = []
                const particules2 = []

                const compositeOps = ['source-over', 'source-in', 'source-out', 'source-atop', 'destination-over', 'destination-in', 'destination-out', 'destination-atop', 'lighter', 'copy', 'xor', 'multiply', 'screen', 'overlay', 'darken', 'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light', 'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity'];

                for (let i = 0; i < maxParticules; i++) {
                    try {
                        const x = randInt(1, W)
                        const y = randInt(1, H)
                        let maxx = Math.max(1, randInt(1, Math.max(1, W - x))); // ensure at least 1x1
                        let maxy = Math.max(1, randInt(1, Math.max(1, H - y)));
                        const data = ctx.getImageData(x, y, maxx, maxy)

                        if (data && data.width > 0 && data.height > 0) {
                            const scale = Math.random() * 2 + 0.5; // random scale 0.5 to 2.5
                            particules.push({
                                x,
                                y,
                                data,
                                scale
                            })
                        }
                    } catch (e) {
                        // ignore
                    }
                }

                for (let i = 0; i < maxParticules; i++) {
                    try {
                        const x = randInt(1, W)
                        const y = randInt(1, H)
                        let maxx = Math.max(1, randInt(1, Math.max(1, W - x)));
                        let maxy = Math.max(1, randInt(1, Math.max(1, H - y)));
                        const data = ctx.getImageData(x, y, maxx, maxy)

                        if (data && data.width > 0 && data.height > 0) {
                            const scale = Math.random() * 2 + 0.5;
                            particules2.push({
                                x,
                                y,
                                data,
                                scale
                            })
                        }
                    } catch (e) {
                        // ignore
                    }
                }

                let angleRad = angle * Math.PI / 180; // convert to radians

                const tempCanvas = createCanvas(W, H);
                const tempCtx = tempCanvas.getContext('2d');

                for (let i = 0; i < cycles; i++) {
                    angleRad += 0.1
                    particules.forEach(p => {
                        const dx = Math.floor(p.x + Math.sin(angleRad) * 100)
                        const dy = Math.floor(p.y + Math.cos(angleRad) * 100)
                        if (isFinite(dx) && isFinite(dy)) {
                            tempCanvas.width = p.data.width;
                            tempCanvas.height = p.data.height;
                            tempCtx.putImageData(p.data, 0, 0);
                            if (compositing) {
                                const op = compositeOps[Math.floor(Math.random() * compositeOps.length)];
                                ctx.globalCompositeOperation = op;
                            }
                            ctx.drawImage(tempCanvas, dx, dy, p.data.width * p.scale, p.data.height * p.scale);
                            if (compositing) {
                                ctx.globalCompositeOperation = 'source-over';
                            }
                        }
                    })
                    particules2.forEach(p => {
                        const dx = Math.floor(Math.sin(angleRad) * 100)
                        const dy = Math.floor(p.y + Math.cos(angleRad) * 100)
                        if (isFinite(dx) && isFinite(dy)) {
                            tempCanvas.width = p.data.width;
                            tempCanvas.height = p.data.height;
                            tempCtx.putImageData(p.data, 0, 0);
                            if (compositing) {
                                const op = compositeOps[Math.floor(Math.random() * compositeOps.length)];
                                ctx.globalCompositeOperation = op;
                            }
                            ctx.drawImage(tempCanvas, dx, dy, p.data.width * p.scale, p.data.height * p.scale);
                            if (compositing) {
                                ctx.globalCompositeOperation = 'source-over';
                            }
                        }
                    })
                }

                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })

    },
    timeEcho: (canvas, ctx, echoes) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                echoes = Math.max(1, Math.min(10, Number(echoes) || 3))
                const imageData = ctx.getImageData(0, 0, W, H)
                const data = imageData.data

                // Glitch Fracture: break into random fragments
                const fragmentSize = Math.max(1, Math.floor(W / echoes))
                for (let fy = 0; fy < H; fy += fragmentSize) {
                    for (let fx = 0; fx < W; fx += fragmentSize) {
                        const randX = randInt(0, W - fragmentSize)
                        const randY = randInt(0, H - fragmentSize)
                        for (let y = 0; y < fragmentSize && fy + y < H; y++) {
                            for (let x = 0; x < fragmentSize && fx + x < W; x++) {
                                const srcIdx = ((randY + y) * W + (randX + x)) * 4
                                const destIdx = ((fy + y) * W + (fx + x)) * 4
                                for (let c = 0; c < 4; c++) {
                                    data[destIdx + c] = data[srcIdx + c]
                                }
                            }
                        }
                    }
                }
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    compositeChaos: (canvas, ctx, layers) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                layers = Math.max(1, Math.min(10, Number(layers) || 5))
                const ops = ['source-over', 'source-in', 'source-out', 'source-atop', 'destination-over', 'destination-in', 'destination-out', 'destination-atop', 'lighter', 'copy', 'xor', 'multiply', 'screen', 'overlay', 'darken', 'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light', 'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity']

                for (let i = 0; i < layers; i++) {
                    const op = ops[Math.floor(Math.random() * ops.length)]
                    ctx.globalCompositeOperation = op
                    const offsetX = randInt(-W/4, W/4)
                    const offsetY = randInt(-H/4, H/4)
                    const scale = 0.8 + Math.random() * 0.4
                    ctx.save()
                    ctx.translate(W/2 + offsetX, H/2 + offsetY)
                    ctx.scale(scale, scale)
                    ctx.rotate(Math.random() * Math.PI * 2)
                    ctx.drawImage(canvas, -W/2, -H/2)
                    ctx.restore()
                }
                ctx.globalCompositeOperation = 'source-over'
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    channelMosaic: (canvas, ctx, gridSize) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                gridSize = Math.max(2, Math.min(20, Number(gridSize) || 8))
                const imageData = ctx.getImageData(0, 0, W, H)
                const data = imageData.data
                const cellW = Math.floor(W / gridSize)
                const cellH = Math.floor(H / gridSize)

                for (let gy = 0; gy < gridSize; gy++) {
                    for (let gx = 0; gx < gridSize; gx++) {
                        const op = randInt(0, 4) // 0: invert R, 1: invert G, 2: invert B, 3: swap RG, 4: swap GB
                        for (let y = gy * cellH; y < (gy + 1) * cellH && y < H; y++) {
                            for (let x = gx * cellW; x < (gx + 1) * cellW && x < W; x++) {
                                const idx = (y * W + x) * 4
                                if (op === 0) data[idx] = 255 - data[idx]
                                else if (op === 1) data[idx + 1] = 255 - data[idx + 1]
                                else if (op === 2) data[idx + 2] = 255 - data[idx + 2]
                                else if (op === 3) [data[idx], data[idx + 1]] = [data[idx + 1], data[idx]]
                                else if (op === 4) [data[idx + 1], data[idx + 2]] = [data[idx + 2], data[idx + 1]]
                            }
                        }
                    }
                }
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    dataVortex: (canvas, ctx, rotations) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                rotations = Math.max(1, Math.min(100, Number(rotations) || 10))
                const imageData = ctx.getImageData(0, 0, W, H)
                const data = imageData.data
                const totalPixels = W * H
                const rotated = new Uint8ClampedArray(data.length)

                for (let rot = 0; rot < rotations; rot++) {
                    const shift = randInt(1, totalPixels * 4)
                    for (let i = 0; i < data.length; i++) {
                        rotated[i] = data[(i + shift) % data.length]
                    }
                    data.set(rotated)
                }
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    spectralRift: (canvas, ctx, rifts) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                rifts = Math.max(1, Math.min(20, Number(rifts) || 5))
                const imageData = ctx.getImageData(0, 0, W, H)
                const data = imageData.data

                for (let r = 0; r < rifts; r++) {
                    const x1 = randInt(0, W - 50)
                    const y1 = randInt(0, H - 50)
                    const w1 = randInt(20, Math.min(100, W - x1))
                    const h1 = randInt(20, Math.min(100, H - y1))
                    const x2 = randInt(0, W - w1)
                    const y2 = randInt(0, H - h1)

                    // Swap two random rectangles
                    const temp = new Uint8ClampedArray(w1 * h1 * 4)
                    for (let y = 0; y < h1; y++) {
                        for (let x = 0; x < w1; x++) {
                            const idx1 = ((y1 + y) * W + (x1 + x)) * 4
                            const idx2 = ((y2 + y) * W + (x2 + x)) * 4
                            for (let c = 0; c < 4; c++) {
                                temp[(y * w1 + x) * 4 + c] = data[idx1 + c]
                                data[idx1 + c] = data[idx2 + c]
                                data[idx2 + c] = temp[(y * w1 + x) * 4 + c]
                            }
                        }
                    }
                }
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    quantumChannelShift: (canvas, ctx, amplitude, direction) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                amplitude = Math.max(1, Math.min(50, Number(amplitude) || 10))
                direction = Number(direction) || 0
                const rad = (direction * Math.PI) / 180
                const imageData = ctx.getImageData(0, 0, W, H)
                const data = imageData.data
                const newData = new Uint8ClampedArray(data)

                for (let y = 0; y < H; y++) {
                    for (let x = 0; x < W; x++) {
                        const idx = (y * W + x) * 4
                        const waveX = x * Math.cos(rad) + y * Math.sin(rad)
                        const waveY = -x * Math.sin(rad) + y * Math.cos(rad)
                        const shiftR = Math.floor(Math.sin(waveX * 0.1) * amplitude)
                        const shiftG = Math.floor(Math.cos(waveY * 0.15) * amplitude)
                        const shiftB = Math.floor(Math.sin((waveX + waveY) * 0.2) * amplitude)

                        const srcR = Math.max(0, Math.min(W - 1, x + shiftR))
                        const srcG = Math.max(0, Math.min(W - 1, x + shiftG))
                        const srcB = Math.max(0, Math.min(W - 1, x + shiftB))

                        newData[idx] = data[(y * W + srcR) * 4]
                        newData[idx + 1] = data[(y * W + srcG) * 4 + 1]
                        newData[idx + 2] = data[(y * W + srcB) * 4 + 2]
                        newData[idx + 3] = data[idx + 3]
                    }
                }
                ctx.putImageData(new ImageData(newData, W, H), 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    channelReverse: (canvas, ctx, rReverse, gReverse, bReverse) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                rReverse = Number(rReverse) || 0
                gReverse = Number(gReverse) || 0
                bReverse = Number(bReverse) || 0
                const imageData = ctx.getImageData(0, 0, W, H)
                const data = imageData.data

                const rArray = []
                const gArray = []
                const bArray = []

                for (let i = 0; i < data.length; i += 4) {
                    rArray.push(data[i])
                    gArray.push(data[i + 1])
                    bArray.push(data[i + 2])
                }

                if (rReverse) rArray.reverse()
                if (gReverse) gArray.reverse()
                if (bReverse) bArray.reverse()

                let idx = 0
                for (let i = 0; i < data.length; i += 4) {
                    data[i] = rArray[idx]
                    data[i + 1] = gArray[idx]
                    data[i + 2] = bArray[idx]
                    idx++
                }

                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    segmentTwist: (canvas, ctx, segmentSize) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                segmentSize = Math.max(1, Math.min(1000, Number(segmentSize) || 100))
                const imageData = ctx.getImageData(0, 0, W, H)
                const data = imageData.data

                const rArray = []
                const gArray = []
                const bArray = []

                for (let i = 0; i < data.length; i += 4) {
                    rArray.push(data[i])
                    gArray.push(data[i + 1])
                    bArray.push(data[i + 2])
                }

                for (let i = 0; i < rArray.length; i += segmentSize) {
                    const end = Math.min(i + segmentSize, rArray.length)
                    const rSeg = rArray.slice(i, end)
                    const gSeg = gArray.slice(i, end)
                    const bSeg = bArray.slice(i, end)

                    if ((i / segmentSize) % 2 === 0) {
                        // Reverse the segment
                        rSeg.reverse()
                        gSeg.reverse()
                        bSeg.reverse()
                    } else {
                        // Rotate RGB: RGB -> BRG -> GBR -> RGB
                        const rot = (i / segmentSize) % 3
                        for (let j = 0; j < rSeg.length; j++) {
                            if (rot === 1) {
                                [rSeg[j], bSeg[j]] = [bSeg[j], rSeg[j]]
                            } else if (rot === 2) {
                                [gSeg[j], bSeg[j]] = [bSeg[j], gSeg[j]]
                            }
                        }
                    }

                    rArray.splice(i, segmentSize, ...rSeg)
                    gArray.splice(i, segmentSize, ...gSeg)
                    bArray.splice(i, segmentSize, ...bSeg)
                }

                let idx = 0
                for (let i = 0; i < data.length; i += 4) {
                    data[i] = rArray[idx]
                    data[i + 1] = gArray[idx]
                    data[i + 2] = bArray[idx]
                    idx++
                }

                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    verticalSliceGlitch: (canvas, ctx, sliceHeight, maxOffset) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                sliceHeight = Math.max(1, Math.min(100, Number(sliceHeight) || 20))
                maxOffset = Math.max(1, Math.min(200, Number(maxOffset) || 20))
                
                const verticalSlices = Math.round(H / sliceHeight)
                
                for (let i = 0; i < verticalSlices; i++) {
                    const horizOffset = randInt(-Math.abs(maxOffset), maxOffset)
                    const sliceY = i * sliceHeight
                    const actualSliceHeight = Math.min(sliceHeight, H - sliceY)
                    
                    ctx.drawImage(
                        canvas,
                        0, sliceY, W, actualSliceHeight,
                        horizOffset, sliceY, W, actualSliceHeight
                    )
                }
                
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    scanlineDisplace: (canvas, ctx, power) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                power = Math.max(0, Math.min(100, Number(power) || 10))
                
                const tempCanvas = createCanvas(W, H)
                const tempCtx = tempCanvas.getContext('2d')
                tempCtx.drawImage(canvas, 0, 0, W, H)
                
                ctx.clearRect(0, 0, W, H)
                
                for (let i = 0; i < H; i++) {
                    const dx = Math.floor((Math.random() - 0.5) * power)
                    ctx.drawImage(tempCanvas, 0, i, W, 1, dx, i, W, 1)
                }
                
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    rowDuplication: (canvas, ctx, probability) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                probability = Math.max(0, Math.min(1, Number(probability) || 0.5))
                
                const imageData = ctx.getImageData(0, 0, W, H)
                const data = imageData.data
                const rowSize = W * 4
                
                const pixelRows = []
                for (let y = 0; y < H; y++) {
                    const row = new Uint8ClampedArray(rowSize)
                    for (let i = 0; i < rowSize; i++) {
                        row[i] = data[y * rowSize + i]
                    }
                    pixelRows.push(row)
                }
                
                for (let i = 1; i < pixelRows.length; i++) {
                    if (Math.random() > probability) {
                        pixelRows[i] = pixelRows[i - 1]
                    }
                }
                
                for (let y = 0; y < H; y++) {
                    for (let i = 0; i < rowSize; i++) {
                        data[y * rowSize + i] = pixelRows[y][i]
                    }
                }
                
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    verticalPixelSort: (canvas, ctx, force, direction) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                force = Math.max(1, Math.min(3000, Number(force) || 10))
                direction = Math.floor(Number(direction) || 0)
                
                const imageData = ctx.getImageData(0, 0, W, H)
                const pixels = imageData.data
                
                const passes = Math.floor(force)
                const dirMode = direction % 2
                
                for (let pass = 0; pass < passes; pass++) {
                    if (dirMode === 0) {
                        for (let y = H - 1; y > 0; y--) {
                            for (let x = 0; x < W; x++) {
                                const i = (x + y * W) * 4
                                const prevI = i - W * 4
                                
                                const currentBrightness = pixels[i] + pixels[i + 1] + pixels[i + 2]
                                const prevBrightness = pixels[prevI] + pixels[prevI + 1] + pixels[prevI + 2]
                                
                                if (currentBrightness > prevBrightness) {
                                    const temp = [pixels[i], pixels[i + 1], pixels[i + 2], pixels[i + 3]]
                                    pixels[i] = pixels[prevI]
                                    pixels[i + 1] = pixels[prevI + 1]
                                    pixels[i + 2] = pixels[prevI + 2]
                                    pixels[i + 3] = pixels[prevI + 3]
                                    pixels[prevI] = temp[0]
                                    pixels[prevI + 1] = temp[1]
                                    pixels[prevI + 2] = temp[2]
                                    pixels[prevI + 3] = temp[3]
                                }
                            }
                        }
                    } else {
                        for (let y = 0; y < H - 1; y++) {
                            for (let x = 0; x < W; x++) {
                                const i = (x + y * W) * 4
                                const nextI = i + W * 4
                                
                                const currentBrightness = pixels[i] + pixels[i + 1] + pixels[i + 2]
                                const nextBrightness = pixels[nextI] + pixels[nextI + 1] + pixels[nextI + 2]
                                
                                if (currentBrightness < nextBrightness) {
                                    const temp = [pixels[i], pixels[i + 1], pixels[i + 2], pixels[i + 3]]
                                    pixels[i] = pixels[nextI]
                                    pixels[i + 1] = pixels[nextI + 1]
                                    pixels[i + 2] = pixels[nextI + 2]
                                    pixels[i + 3] = pixels[nextI + 3]
                                    pixels[nextI] = temp[0]
                                    pixels[nextI + 1] = temp[1]
                                    pixels[nextI + 2] = temp[2]
                                    pixels[nextI + 3] = temp[3]
                                }
                            }
                        }
                    }
                }
                
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    advancedPixelSort: (canvas, ctx, sortMode, direction, separatorMin, separatorMax) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                sortMode = Math.floor(Number(sortMode) || 0)
                direction = Math.floor(Number(direction) || 0)
                const isHslMode = sortMode >= 3
                separatorMin = isHslMode 
                    ? Math.max(0, Math.min(1, Number(separatorMin) || 0.1))
                    : Math.max(0, Math.min(255, Number(separatorMin) || 64))
                separatorMax = isHslMode 
                    ? Math.max(0, Math.min(1, Number(separatorMax) || 0.9))
                    : Math.max(0, Math.min(255, Number(separatorMax) || 192))
                
                const imageData = ctx.getImageData(0, 0, W, H)
                const data = imageData.data
                const reverseOrder = separatorMin > separatorMax
                if (reverseOrder) {
                    [separatorMin, separatorMax] = [separatorMax, separatorMin]
                }
                
                const rgbToHsl = (r, g, b) => {
                    r /= 255; g /= 255; b /= 255
                    const max = Math.max(r, g, b), min = Math.min(r, g, b)
                    let h, s, l = (max + min) / 2
                    if (max === min) {
                        h = s = 0
                    } else {
                        const d = max - min
                        s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
                        switch (max) {
                            case r: h = (g - b) / d + (g < b ? 6 : 0); break
                            case g: h = (b - r) / d + 2; break
                            case b: h = (r - g) / d + 4; break
                        }
                        h /= 6
                    }
                    return { h, s, l }
                }
                
                const getSortValue = (idx) => {
                    const r = data[idx] / 255, g = data[idx + 1] / 255, b = data[idx + 2] / 255
                    const hsl = rgbToHsl(data[idx], data[idx + 1], data[idx + 2])
                    switch (sortMode) {
                        case 0: return r
                        case 1: return g
                        case 2: return b
                        case 3: return hsl.h
                        case 4: return hsl.s
                        case 5: return hsl.l
                        default: return hsl.l
                    }
                }
                
                const shouldSeparate = (idx) => {
                    const val = getSortValue(idx)
                    return val >= separatorMin && val <= separatorMax
                }
                
                const getPoint = (i, dir) => {
                    switch (dir) {
                        case 0: return { x: i % W, y: Math.floor(i / W) }
                        case 1: return { x: Math.floor(i / H), y: i % H }
                        case 2: return { x: (Math.floor(i / H) + (i % H)) % W, y: i % H }
                        case 3: return { x: (Math.floor(i / H) + (i % H)) % W, y: (H * W - i) % H }
                        default: return { x: i % W, y: Math.floor(i / W) }
                    }
                }
                
                let i = 0
                const totalPixels = W * H
                
                while (i < totalPixels - 1) {
                    let start = i
                    while (i < totalPixels && !shouldSeparate((getPoint(i, direction).y * W + getPoint(i, direction).x) * 4)) {
                        i++
                    }
                    const segmentStart = i
                    while (i < totalPixels && shouldSeparate((getPoint(i, direction).y * W + getPoint(i, direction).x) * 4)) {
                        i++
                    }
                    const segmentEnd = i
                    
                    if (segmentEnd - segmentStart > 1) {
                        const segment = []
                        for (let j = segmentStart; j < segmentEnd; j++) {
                            const pt = getPoint(j, direction)
                            const idx = (pt.y * W + pt.x) * 4
                            segment.push({
                                r: data[idx],
                                g: data[idx + 1],
                                b: data[idx + 2],
                                a: data[idx + 3],
                                sortVal: getSortValue(idx)
                            })
                        }
                        
                        segment.sort((a, b) => reverseOrder ? b.sortVal - a.sortVal : a.sortVal - b.sortVal)
                        
                        for (let j = 0; j < segment.length; j++) {
                            const pt = getPoint(segmentStart + j, direction)
                            const idx = (pt.y * W + pt.x) * 4
                            data[idx] = segment[j].r
                            data[idx + 1] = segment[j].g
                            data[idx + 2] = segment[j].b
                            data[idx + 3] = segment[j].a
                        }
                    }
                }
                
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    neighborDifferenceSort: (canvas, ctx, intensity) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                intensity = Math.max(0, Math.min(1, Number(intensity) || 1))
                
                const imageData = ctx.getImageData(0, 0, W, H)
                const d = imageData.data
                const l = d.length
                
                const neighborOffsets = [
                    -1, -1,  0, -1,  1, -1,
                    -1,  0,          1,  0,
                    -1,  1,  0,  1,  1,  1
                ]
                
                const pixels = []
                for (let i = 0; i < l; i += 4) {
                    const x = (i / 4) % W
                    const y = Math.floor(i / 4 / W)
                    
                    let sum = 0
                    let summed = 0
                    
                    for (let n = 0; n < neighborOffsets.length; n += 2) {
                        const nx = x + neighborOffsets[n]
                        const ny = y + neighborOffsets[n + 1]
                        const ni = ny * W * 4 + nx * 4
                        
                        if (nx >= 0 && nx < W && ny >= 0 && ny < H && ni >= 0 && ni < l) {
                            const dist = Math.sqrt(
                                Math.pow(d[i + 0] - d[ni + 0], 2) +
                                Math.pow(d[i + 1] - d[ni + 1], 2) +
                                Math.pow(d[i + 2] - d[ni + 2], 2)
                            )
                            summed++
                            sum += dist
                        }
                    }
                    
                    const avg = summed > 0 ? sum / summed : 0
                    pixels.push({
                        r: d[i],
                        g: d[i + 1],
                        b: d[i + 2],
                        a: d[i + 3],
                        diff: avg
                    })
                }
                
                pixels.sort((a, b) => a.diff - b.diff)
                
                const sortedCount = Math.floor(pixels.length * intensity)
                for (let i = 0; i < sortedCount; i++) {
                    d[i * 4] = pixels[i].r
                    d[i * 4 + 1] = pixels[i].g
                    d[i * 4 + 2] = pixels[i].b
                    d[i * 4 + 3] = pixels[i].a
                }
                
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    hsvPixelSort: (canvas, ctx, sortOrder) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                sortOrder = Math.floor(Number(sortOrder) || 0)
                
                const imageData = ctx.getImageData(0, 0, W, H)
                const pixels = imageData.data
                
                const rgb2hsv = (r, g, b) => {
                    r = r / 255
                    g = g / 255
                    b = b / 255
                    const minRGB = Math.min(r, Math.min(g, b))
                    const maxRGB = Math.max(r, Math.max(g, b))
                    
                    if (minRGB === maxRGB) {
                        return [0, 0, minRGB]
                    }
                    
                    const d = (r === minRGB) ? g - b : ((b === minRGB) ? r - g : b - r)
                    const h = (r === minRGB) ? 3 : ((b === minRGB) ? 1 : 5)
                    const computedH = 60 * (h - d / (maxRGB - minRGB))
                    const computedS = (maxRGB - minRGB) / maxRGB
                    const computedV = maxRGB
                    
                    return [computedH, computedS, computedV]
                }
                
                const pixelsReformat = []
                for (let i = 0; i < pixels.length; i += 4) {
                    const hsv = rgb2hsv(pixels[i], pixels[i + 1], pixels[i + 2])
                    pixelsReformat.push({
                        r: pixels[i],
                        g: pixels[i + 1],
                        b: pixels[i + 2],
                        a: pixels[i + 3],
                        h: hsv[0],
                        s: hsv[1],
                        v: hsv[2]
                    })
                }
                
                switch (sortOrder) {
                    case 0:
                        pixelsReformat.sort((a, b) => a.h - b.h)
                        break
                    case 1:
                        pixelsReformat.sort((a, b) => a.s - b.s)
                        break
                    case 2:
                        pixelsReformat.sort((a, b) => a.v - b.v)
                        break
                    case 3:
                        pixelsReformat.sort((a, b) => a.s - b.s)
                        pixelsReformat.sort((a, b) => a.h - b.h)
                        break
                    case 4:
                        pixelsReformat.sort((a, b) => a.v - b.v)
                        pixelsReformat.sort((a, b) => a.h - b.h)
                        break
                    case 5:
                        pixelsReformat.sort((a, b) => a.s - b.s)
                        pixelsReformat.sort((a, b) => a.h - b.h)
                        pixelsReformat.sort((a, b) => a.v - b.v)
                        break
                }
                
                for (let i = 0; i < pixelsReformat.length; i++) {
                    pixels[i * 4] = pixelsReformat[i].r
                    pixels[i * 4 + 1] = pixelsReformat[i].g
                    pixels[i * 4 + 2] = pixelsReformat[i].b
                    pixels[i * 4 + 3] = pixelsReformat[i].a
                }
                
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    shiftRGB: (canvas, ctx, shiftR, shiftG, shiftB, blend) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                shiftR = Math.floor(Number(shiftR) || 0)
                shiftG = Math.floor(Number(shiftG) || 0)
                shiftB = Math.floor(Number(shiftB) || 0)
                blend = Math.max(0, Math.min(1, Number(blend) || 0.8))
                
                const imageData = ctx.getImageData(0, 0, W, H)
                const srcPixels = imageData.data
                const destPixels = new Uint8ClampedArray(srcPixels)
                
                const shift = [
                    shiftR * 4,
                    shiftG * 4,
                    shiftB * 4
                ]
                
                for (let i = 0; i < srcPixels.length; i += 4) {
                    for (let ch = 0; ch < 3; ch++) {
                        let srcIdx = i + ch + shift[ch]
                        if (srcIdx < 0) srcIdx = srcPixels.length + srcIdx
                        srcIdx = srcIdx % srcPixels.length
                        
                        destPixels[i + ch] = srcPixels[i + ch] * (1 - blend) + srcPixels[srcIdx] * blend
                    }
                }
                
                imageData.data.set(destPixels)
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    tvStatic: (canvas, ctx, amount, monochrome) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                amount = Math.max(0, Math.min(1, Number(amount) || 0.5))
                monochrome = Math.floor(Number(monochrome) || 0)
                
                const imageData = ctx.getImageData(0, 0, W, H)
                const pixels = imageData.data
                
                for (let i = 0; i < pixels.length; i += 4) {
                    if (monochrome > 0) {
                        const noise = Math.random() * 255
                        pixels[i] = pixels[i] * (1 - amount) + noise * amount
                        pixels[i + 1] = pixels[i + 1] * (1 - amount) + noise * amount
                        pixels[i + 2] = pixels[i + 2] * (1 - amount) + noise * amount
                    } else {
                        pixels[i] = pixels[i] * (1 - amount) + Math.random() * 255 * amount
                        pixels[i + 1] = pixels[i + 1] * (1 - amount) + Math.random() * 255 * amount
                        pixels[i + 2] = pixels[i + 2] * (1 - amount) + Math.random() * 255 * amount
                    }
                }
                
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    sobelEdgeGlitch: (canvas, ctx, threshold, sortIntensity, edgeMode, blendAmount) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                threshold = Math.max(0, Math.min(255, Number(threshold) || 50))
                sortIntensity = Math.max(0, Math.min(100, Number(sortIntensity) || 50))
                edgeMode = Math.floor(Number(edgeMode) || 0)
                blendAmount = Math.max(0, Math.min(1, Number(blendAmount) || 0.5))
                
                const imageData = ctx.getImageData(0, 0, W, H)
                const pixels = imageData.data
                const originalPixels = new Uint8ClampedArray(pixels)
                
                const grayscale = new Uint8ClampedArray(W * H)
                for (let i = 0; i < pixels.length; i += 4) {
                    grayscale[i / 4] = 0.299 * pixels[i] + 0.587 * pixels[i + 1] + 0.114 * pixels[i + 2]
                }
                
                const sobelData = new Uint8ClampedArray(W * H)
                const kernelX = [-1, 0, 1, -2, 0, 2, -1, 0, 1]
                const kernelY = [-1, -2, -1, 0, 0, 0, 1, 2, 1]
                
                for (let y = 1; y < H - 1; y++) {
                    for (let x = 1; x < W - 1; x++) {
                        let gx = 0, gy = 0
                        for (let ky = -1; ky <= 1; ky++) {
                            for (let kx = -1; kx <= 1; kx++) {
                                const idx = (y + ky) * W + (x + kx)
                                const kidx = (ky + 1) * 3 + (kx + 1)
                                gx += grayscale[idx] * kernelX[kidx]
                                gy += grayscale[idx] * kernelY[kidx]
                            }
                        }
                        const magnitude = Math.sqrt(gx * gx + gy * gy)
                        sobelData[y * W + x] = magnitude > threshold ? 255 : 0
                    }
                }
                
                if (edgeMode === 0) {
                    for (let y = 0; y < H; y++) {
                        const edgePixels = []
                        const normalPixels = []
                        
                        for (let x = 0; x < W; x++) {
                            const idx = y * W + x
                            const pixelIdx = idx * 4
                            const pixel = {
                                r: pixels[pixelIdx],
                                g: pixels[pixelIdx + 1],
                                b: pixels[pixelIdx + 2],
                                a: pixels[pixelIdx + 3],
                                brightness: pixels[pixelIdx] + pixels[pixelIdx + 1] + pixels[pixelIdx + 2],
                                isEdge: sobelData[idx] > 0
                            }
                            
                            if (pixel.isEdge) edgePixels.push({ ...pixel, x })
                            else normalPixels.push({ ...pixel, x })
                        }
                        
                        if (edgePixels.length > sortIntensity / 10) {
                            edgePixels.sort((a, b) => a.brightness - b.brightness)
                        }
                        
                        edgePixels.forEach((p, i) => {
                            const idx = (y * W + p.x) * 4
                            pixels[idx] = p.r
                            pixels[idx + 1] = p.g
                            pixels[idx + 2] = p.b
                            pixels[idx + 3] = p.a
                        })
                    }
                } else if (edgeMode === 1) {
                    for (let y = 0; y < H; y++) {
                        for (let x = 0; x < W; x++) {
                            const idx = y * W + x
                            if (sobelData[idx] > 0) {
                                const offset = Math.floor((Math.random() - 0.5) * sortIntensity) * 4
                                const srcIdx = (y * W + x) * 4
                                let destIdx = srcIdx + offset
                                
                                if (destIdx >= y * W * 4 && destIdx < (y + 1) * W * 4 - 4) {
                                    for (let ch = 0; ch < 3; ch++) {
                                        pixels[srcIdx + ch] = originalPixels[destIdx + ch]
                                    }
                                }
                            }
                        }
                    }
                } else {
                    for (let i = 0; i < pixels.length; i += 4) {
                        const idx = i / 4
                        if (sobelData[idx] > 0) {
                            const edge = sobelData[idx]
                            pixels[i] = pixels[i] * (1 - blendAmount) + edge * blendAmount
                            pixels[i + 1] = pixels[i + 1] * (1 - blendAmount) + edge * blendAmount
                            pixels[i + 2] = pixels[i + 2] * (1 - blendAmount) + edge * blendAmount
                        }
                    }
                }
                
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    verticalSliceOffset: (canvas, ctx, sliceHeight, maxOffset, probability, verticalJitter) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                sliceHeight = Math.max(1, Math.min(200, Math.floor(Number(sliceHeight) || 20)))
                maxOffset = Math.max(0, Math.min(W / 2, Math.floor(Number(maxOffset) || W / 5)))
                probability = Math.max(0, Math.min(1, Number(probability) || 0.99))
                verticalJitter = Math.max(0, Math.min(100, Math.floor(Number(verticalJitter) || 0)))
                
                const tempCanvas = createCanvas(W, H)
                const tempCtx = tempCanvas.getContext('2d')
                tempCtx.drawImage(canvas, 0, 0)
                
                ctx.clearRect(0, 0, W, H)
                
                const verticalSlices = Math.round(H / sliceHeight)
                
                for (let i = 0; i < verticalSlices; i++) {
                    if (Math.random() > (1 - probability)) {
                        const horizOffset = Math.floor(Math.random() * (maxOffset * 2) - maxOffset)
                        const yPos = i * sliceHeight
                        const jitter = verticalJitter > 0 
                            ? Math.floor(Math.random() * verticalJitter - verticalJitter / 2)
                            : 0
                        const destY = yPos + Math.floor(Math.random() * (sliceHeight / 4) + jitter)
                        
                        ctx.drawImage(
                            tempCanvas,
                            0,
                            yPos,
                            W,
                            sliceHeight,
                            horizOffset,
                            destY,
                            W,
                            sliceHeight
                        )
                    } else {
                        ctx.drawImage(
                            tempCanvas,
                            0,
                            i * sliceHeight,
                            W,
                            sliceHeight,
                            0,
                            i * sliceHeight,
                            W,
                            sliceHeight
                        )
                    }
                }
                
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    horizontalShiftLines: (canvas, ctx, rows, maxShift, minHeight, maxHeight) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                rows = Math.max(1, Math.min(100, Math.floor(Number(rows) || 6)))
                maxShift = Math.max(1, Math.min(200, Math.floor(Number(maxShift) || 40)))
                minHeight = Math.max(1, Math.min(100, Math.floor(Number(minHeight) || 1)))
                maxHeight = Math.max(minHeight, Math.min(H, Math.floor(Number(maxHeight) || 50)))
                
                const imageData = ctx.getImageData(0, 0, W, H)
                const srcPixels = new Uint8ClampedArray(imageData.data)
                const destPixels = new Uint8ClampedArray(srcPixels)
                
                for (let i = 0; i < rows; i++) {
                    const yMin = Math.floor(Math.random() * H)
                    const yMax = Math.min(H, yMin + Math.floor(Math.random() * (maxHeight - minHeight) + minHeight))
                    const xOffset = Math.floor(Math.random() * maxShift * 2 - maxShift) * 4
                    
                    for (let y = yMin; y < yMax; y++) {
                        for (let x = 0; x < W; x++) {
                            const srcIdx = (y * W + x) * 4
                            let destX = x
                            let offsetIdx = srcIdx + xOffset
                            
                            if (offsetIdx < y * W * 4) offsetIdx = y * W * 4
                            if (offsetIdx >= (y + 1) * W * 4) offsetIdx = (y + 1) * W * 4 - 4
                            
                            for (let ch = 0; ch < 3; ch++) {
                                destPixels[srcIdx + ch] = srcPixels[offsetIdx + ch]
                            }
                        }
                    }
                }
                
                imageData.data.set(destPixels)
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    sliceDisplacement: (canvas, ctx, slices, blendMode, opacity, minHeight) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                slices = Math.max(1, Math.min(500, Math.floor(Number(slices) || 60)))
                blendMode = Math.floor(Number(blendMode) || 0)
                opacity = Math.max(0, Math.min(1, Number(opacity) || 1))
                minHeight = Math.max(1, Math.min(100, Math.floor(Number(minHeight) || 5)))
                
                const blendModes = [
                    'difference', 'source-atop', 'destination-out', 'lighter',
                    'multiply', 'screen', 'overlay', 'darken', 'lighten',
                    'color-dodge', 'color-burn', 'hard-light', 'soft-light',
                    'exclusion', 'hue', 'color', 'luminosity'
                ]
                
                const tempCanvas = createCanvas(W, H)
                const tempCtx = tempCanvas.getContext('2d')
                tempCtx.drawImage(canvas, 0, 0)
                
                ctx.globalAlpha = opacity
                ctx.globalCompositeOperation = blendModes[blendMode % blendModes.length]
                ctx.imageSmoothingEnabled = false
                
                const sliceHeight = H / slices
                
                for (let i = 0; i < slices; i++) {
                    const sourceY = i * sliceHeight
                    const sourceX = Math.floor(Math.random() * (W / 2))
                    const glitchWidth = Math.floor(Math.random() * (W * 0.7) + W * 0.3)
                    const glitchHeight = Math.max(minHeight, Math.floor(Math.random() * (H / 4) + minHeight))
                    const destinationX = Math.floor(Math.random() * (W / 1.75))
                    
                    ctx.drawImage(
                        tempCanvas,
                        sourceX,
                        sourceY,
                        glitchWidth,
                        glitchHeight,
                        destinationX,
                        sourceY,
                        glitchWidth,
                        glitchHeight
                    )
                }
                
                ctx.globalAlpha = 1
                ctx.globalCompositeOperation = 'source-over'
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    kaleidoscopeGlitch: (canvas, ctx, segments, colorShift, rotation, chaos) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                segments = Math.max(2, Math.min(16, Math.floor(Number(segments) || 6)))
                colorShift = Math.max(0, Math.min(360, Number(colorShift) || 0))
                rotation = Number(rotation) || 0
                chaos = Math.max(0, Math.min(100, Number(chaos) || 0))
                
                const imageData = ctx.getImageData(0, 0, W, H)
                const pixels = imageData.data
                const tempCanvas = createCanvas(W, H)
                const tempCtx = tempCanvas.getContext('2d')
                tempCtx.putImageData(imageData, 0, 0)
                
                ctx.clearRect(0, 0, W, H)
                ctx.save()
                ctx.translate(W / 2, H / 2)
                ctx.rotate((rotation * Math.PI) / 180)
                
                const angleStep = (2 * Math.PI) / segments
                
                for (let i = 0; i < segments; i++) {
                    ctx.save()
                    ctx.rotate(i * angleStep)
                    
                    if (i % 2 === 1) {
                        ctx.scale(-1, 1)
                    }
                    
                    const chaosOffset = chaos > 0 ? (Math.random() - 0.5) * chaos * 0.01 : 0
                    ctx.translate(chaosOffset * W, chaosOffset * H)
                    
                    if (colorShift > 0) {
                        const hueRotate = ((colorShift * i) / segments) % 360
                        ctx.filter = `hue-rotate(${hueRotate}deg) saturate(${1 + chaos * 0.01})`
                    }
                    
                    ctx.drawImage(tempCanvas, -W / 2, -H / 2, W, H)
                    ctx.restore()
                }
                
                ctx.restore()
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
    thresholdPixelSort: (canvas, ctx, minThreshold, maxThreshold, sortMode, direction) => {
        return new Promise((resolve, reject) => {
            try {
                const H = canvas.height
                const W = canvas.width
                minThreshold = Math.max(0, Math.min(255, Number(minThreshold) || 0))
                maxThreshold = Math.max(0, Math.min(255, Number(maxThreshold) || 255))
                sortMode = Math.floor(Number(sortMode) || 0)
                direction = Math.floor(Number(direction) || 0)
                
                const imageData = ctx.getImageData(0, 0, W, H)
                const data = imageData.data
                const reverseOrder = minThreshold > maxThreshold
                
                const rgbToBrightness = (r, g, b) => 0.299 * r + 0.587 * g + 0.114 * b
                
                const rgbToHue = (r, g, b) => {
                    r /= 255; g /= 255; b /= 255
                    const max = Math.max(r, g, b), min = Math.min(r, g, b)
                    if (max === min) return 0
                    let h
                    if (max === r) h = (60 * ((g - b) / (max - min)) + 360) % 360
                    else if (max === g) h = 60 * ((b - r) / (max - min)) + 120
                    else h = 60 * ((r - g) / (max - min)) + 240
                    return h
                }
                
                const rgbToSaturation = (r, g, b) => {
                    r /= 255; g /= 255; b /= 255
                    const max = Math.max(r, g, b), min = Math.min(r, g, b)
                    const l = (max + min) / 2
                    if (max === min) return 0
                    const s = (l < 0.5) ? (max - min) / (max + min) : (max - min) / (2.0 - max - min)
                    return Math.round(s * 255)
                }
                
                const getValue = (r, g, b) => {
                    switch (sortMode) {
                        case 0: return rgbToBrightness(r, g, b)
                        case 1: return rgbToHue(r, g, b)
                        case 2: return rgbToSaturation(r, g, b)
                        case 3: return r
                        case 4: return g
                        case 5: return b
                        default: return rgbToBrightness(r, g, b)
                    }
                }
                
                if (direction === 0 || direction === 1) {
                    for (let y = 0; y < H; y++) {
                        const row = []
                        for (let x = 0; x < W; x++) {
                            const index = (y * W + x) * 4
                            const r = data[index], g = data[index + 1], b = data[index + 2], a = data[index + 3]
                            const value = getValue(r, g, b)
                            const inRange = reverseOrder ? value <= minThreshold && value >= maxThreshold : value >= minThreshold && value <= maxThreshold
                            row.push({ r, g, b, a, value, inRange })
                        }
                        
                        if (direction === 1) row.reverse()
                        
                        row.sort((a, b) => {
                            if (a.inRange && b.inRange) return reverseOrder ? b.value - a.value : a.value - b.value
                            return a.inRange ? -1 : 1
                        })
                        
                        if (direction === 1) row.reverse()
                        
                        for (let x = 0; x < W; x++) {
                            const index = (y * W + x) * 4
                            data[index] = row[x].r
                            data[index + 1] = row[x].g
                            data[index + 2] = row[x].b
                            data[index + 3] = row[x].a
                        }
                    }
                } else {
                    for (let x = 0; x < W; x++) {
                        const column = []
                        for (let y = 0; y < H; y++) {
                            const index = (y * W + x) * 4
                            const r = data[index], g = data[index + 1], b = data[index + 2], a = data[index + 3]
                            const value = getValue(r, g, b)
                            const inRange = reverseOrder ? value <= minThreshold && value >= maxThreshold : value >= minThreshold && value <= maxThreshold
                            column.push({ r, g, b, a, value, inRange })
                        }
                        
                        if (direction === 3) column.reverse()
                        
                        column.sort((a, b) => {
                            if (a.inRange && b.inRange) return reverseOrder ? b.value - a.value : a.value - b.value
                            return a.inRange ? -1 : 1
                        })
                        
                        if (direction === 3) column.reverse()
                        
                        for (let y = 0; y < H; y++) {
                            const index = (y * W + x) * 4
                            data[index] = column[y].r
                            data[index + 1] = column[y].g
                            data[index + 2] = column[y].b
                            data[index + 3] = column[y].a
                        }
                    }
                }
                
                ctx.putImageData(imageData, 0, 0)
                resolve()
            } catch (e) {
                console.error(e)
                reject(e)
            }
        })
    },
}

// ---- Glitchedit bridge: add all 48 effects from HelgeSverre/glitchedit ----
const glitcheditBridge = require('./glitchedit-bridge')
const bridgedEffects = glitcheditBridge.buildBridgedEffects()
for (const [effectId, bridgedFn] of Object.entries(bridgedEffects)) {
    lib['ge-' + effectId] = bridgedFn
}

// ---- OpenMosh bridge: add all WebGL2 GLSL effects from zivavu/OpenMosh ----
const openmoshBridge = require('./openmosh-bridge')
const openmoshEffects = openmoshBridge.buildBridgedEffects()
for (const [effectId, bridgedFn] of Object.entries(openmoshEffects)) {
    lib['om-' + effectId] = bridgedFn
}

// ---- Errorhead bridge: add all WebGL2 GLSL effects from eg0pr0xy/errorhead ----
const errorheadBridge = require('./errorhead-bridge')
const errorheadEffects = errorheadBridge.buildBridgedEffects()
for (const [effectId, bridgedFn] of Object.entries(errorheadEffects)) {
    lib['eh-' + effectId] = bridgedFn
}

// ---- Databender bridge: add all raw BMP byte corruption effects from snicker02/Databender ----
const databenderBridge = require('./databender-bridge')
const databenderEffects = databenderBridge.buildBridgedEffects()
for (const [effectId, bridgedFn] of Object.entries(databenderEffects)) {
    lib['db-' + effectId] = bridgedFn
}

// ---- Extra FX: codec, generative, film, print, color, text, analysis ----
const extraFx = require('./extra-fx')
Object.assign(lib, extraFx.lib)

// ---- Dithering FX (ported from Oslonline/dithering-studio, Apache-2.0) ----
const dither = require('./dither')
Object.assign(lib, dither)

module.exports = lib